export default __webpack_public_path__ + "static/customer-38a822d9b4a9a51ded3bf69a0826c5fe.png";